import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";
import type OrganisationTeam from "./OrganisationTeam";
import type User from "./User";

@Model()
class StreamGroup extends ApplicationRecord {
  static jsonapiType = "stream_groups";

  @Attr() color: string;

  @Attr() label: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @BelongsTo() organisationTeam: OrganisationTeam;

  @Attr() organisationTeamId: number;

  @Attr() organisationTeamIds: number[];

  @Attr() position: number;

  @Attr({ persist: false }) slug: string;

  @Attr() streamType: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default StreamGroup;
